import { render, staticRenderFns } from "./ForgotPasswordOTP.vue?vue&type=template&id=7c7ecdf0"
import script from "./ForgotPasswordOTP.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordOTP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports